import cleanedFilename from '~/util/cleanedFilename';

export default {
  OVERVIEW_HEADER: `${cleanedFilename(__filename)}-overview-header`,
  IMPORT_FLOW: `${cleanedFilename(__filename)}-import-flow`,
};
